// extracted by mini-css-extract-plugin
export var container = "styles-module__container___CYgLf";
export var description = "styles-module__description___eKDgL";
export var title = "styles-module__title___Iw754";